
import { toast } from "sonner";
import { checkRateLimit } from "@/utils/security";
import { signOutUser, refreshUserSession } from "@/utils/authUtils";
import { AuthStateType } from "./useAuthState";

/**
 * Custom hook for session management functions
 */
export const useSessionManagement = (authState: AuthStateType) => {
  const { setIsLoading, setSession, setUser, isMounted } = authState;

  // Enhanced sign out with security checks
  const signOut = async () => {
    // Check rate limit for sign out actions
    if (!checkRateLimit('auth:signOut', 5, 60000)) {
      return;
    }
    
    await signOutUser();
    
    // Clean up any secure storage
    localStorage.removeItem('sessionId');
    sessionStorage.clear();
  };

  // Enhanced session refresh with security checks
  const refreshSession = async () => {
    try {
      // Check rate limit for refresh actions
      if (!checkRateLimit('auth:refreshSession', 5, 60000)) {
        return;
      }
      
      if (!isMounted.current) return;
      
      const { data, error } = await refreshUserSession(setIsLoading);
      
      if (error) throw error;
      
      if (isMounted.current) {
        setSession(data.session);
        setUser(data.session?.user ?? null);
      }
    } catch (error: any) {
      toast.error("Failed to refresh session: " + error.message);
    }
  };

  return { signOut, refreshSession };
};
